import {
  ApplicationRef,
  ComponentRef,
  EnvironmentInjector,
  Injectable,
  createComponent,
} from '@angular/core';
import { ExitSubscriptionModalComponent } from '../components/exit-subscription-modal/exit-subscription-modal.component';

@Injectable({ providedIn: 'root' })
export class SubscriptionExitService {
  private modalRef?: ComponentRef<ExitSubscriptionModalComponent>;
  private pendingDecision?: (leave: boolean) => void;

  constructor(
    private readonly appRef: ApplicationRef,
    private readonly injector: EnvironmentInjector
  ) {}

  attachModal(): void {
    if (this.modalRef) return;

    const modalRef = createComponent(ExitSubscriptionModalComponent, {
      environmentInjector: this.injector,
    });
    modalRef.instance.stay.subscribe(() => this.decide(false));
    modalRef.instance.leave.subscribe(() => this.decide(true));
    this.appRef.attachView(modalRef.hostView);
    document.body.appendChild(modalRef.location.nativeElement);
    modalRef.changeDetectorRef.detectChanges();

    this.modalRef = modalRef;
  }

  confirmExit(): Promise<boolean> {
    this.pendingDecision?.(false);
    this.setOpen(true);

    return new Promise((resolve) => {
      this.pendingDecision = resolve;
    });
  }

  private decide(leave: boolean): void {
    this.setOpen(false);
    this.pendingDecision?.(leave);
    this.pendingDecision = undefined;
  }

  private setOpen(isOpen: boolean): void {
    this.attachModal();
    this.modalRef?.setInput('isOpen', isOpen);
    this.modalRef?.changeDetectorRef.detectChanges();
  }
}
